import { Button, Grid, IconButton, InputAdornment, Typography } from "@mui/material"
import { usePageTitle } from "../../hooks"
import { Constants, Validators } from "../../utils"
import { InputComponent } from "../../components/input"
import { useForm } from "react-hook-form"
import { useState } from "react"
import { IoMdEye, IoMdEyeOff } from "react-icons/io"
import { LoadingButton } from "@mui/lab"
import { AuthService } from "../../services/auth"
import useAuth from "../../context/auth"
import { Storage } from "../../storage"
import LoginImg from "../../assets/img/login register.png"
import Logo from "../../assets/img/logo animation.svg"
import { useNavigate } from "react-router-dom"

export const Login = ({ isClient = true }: { isClient?: boolean }) => {
    usePageTitle("Login")

    type HookFormData = { email: string, password: string }

    const {
        register,
        watch,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues
    } = useForm<HookFormData>()

    const { setIsAuthenticated, setUser } = useAuth()
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)

    const login = ({
        email,
        password
    }: HookFormData) => {
        setLoading(true)

        AuthService.login({
            identification: email,
            password,
            role: isClient ? 5 : 20
        })
            .then(({ data }) => {
                Storage.saveTokens({
                    access: data.access,
                    refresh: data.refresh
                })

                Storage.saveUser(data?.userData)
                setUser(data?.userData)
                setIsAuthenticated(true)
            })
            .finally(() => setLoading(false))
    }

    return (
        <Grid
            sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
            }}
        >
            <Grid
                container
                sx={{
                    maxWidth: `${Constants.screenMaxWidth}px`,
                    width: "100vw",
                    height: "calc(100vh - 100px)",
                    display: "flex",
                    gap: "1rem",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "nowrap",
                }}
            >

                <img
                    src={Logo}
                    alt="Logo"
                    style={{
                        width: "8.3rem",
                        height: "3.8rem",
                        marginTop: "20px"
                    }}
                />
                <img
                    src={LoginImg}
                    style={{
                        width: "100%",
                        background: "linear-gradient(180deg, rgba(97, 173, 240, 0.2) 0%, rgba(0, 136, 255, 0.2) 84.4%, rgba(255, 255, 255, 0.2) 100%)",
                        padding: "12rem 0px 1rem",
                        marginTop: "-10rem"
                    }}
                />
                <Grid
                    width={"100%"}
                    display={"flex"}
                    direction={"column"}
                    alignItems={"center"}
                    gap={"2rem"}
                    pb={"2rem"}
                >
                    <Grid
                        width={"90%"}
                    >
                        <Typography
                            fontSize={"3.2rem"}
                            fontWeight={700}
                            textAlign={"start"}
                        >
                            Fazer login
                        </Typography>

                        <Typography
                            fontSize={"1.6rem"}
                            fontWeight={400}
                            textAlign={"start"}
                            sx={{
                                opacity: .5
                            }}
                            mb={2}
                            mt={-.5}
                        >
                            Use seu e-mail ou CPF para fazer login
                        </Typography>
                    </Grid>

                    <InputComponent
                        label="Digite o seu CPF ou E-mail"
                        value={watch("email") || ""}
                        onChangeValue={(value) => setValue("email", value, { shouldValidate: true })}
                        error={!!errors.email}
                        helperText={errors.email?.message}
                        disabled={loading}
                        {...register("email", {
                            required: {
                                value: true,
                                message: "Informe o seu CPF ou E-mail"
                            },
                        })}
                    />

                    <InputComponent
                        type={visible ? "text" : "password"}
                        label="Digite sua senha"
                        value={watch("password") || ""}
                        onChangeValue={(value) => setValue("password", value, { shouldValidate: true })}
                        error={!!errors.password}
                        helperText={errors.password?.message}
                        disabled={loading}
                        {...register("password", {
                            required: {
                                value: true,
                                message: "Informe seu E-mail"
                            },
                            minLength: {
                                value: 4,
                                message: "A senha deve conter no mínimo 4 dígitos."
                            }
                        })}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton onClick={() => setVisible(!visible)}>
                                    {visible ? <IoMdEye size={24} /> : <IoMdEyeOff size={24} />}
                                </IconButton>
                            </InputAdornment>
                        }
                    />

                    <Button
                        variant="text"
                        sx={{
                            mt: -2,
                            mb: -1,
                            textDecoration: "underline"
                        }}
                        onClick={() => navigate(isClient ? "/recuperar-acesso" : "/parceiro/recuperar-acesso", { state: { access: getValues("email") } })}
                    >
                        Esqueceu sua senha?
                    </Button>


                    {!isClient && <Button
                        variant="text"
                        sx={{
                            mt: -2,
                            mb: -1,
                            textDecoration: "underline",
                            color: "gray"
                        }}
                        onClick={() => navigate("/parceiro/cadastro")}
                    >
                        Quero ser parceiro
                    </Button>}

                    <LoadingButton
                        variant="contained"
                        loading={loading}
                        onClick={handleSubmit(login)}
                        sx={{
                            background: "linear-gradient(90deg, #178BF1 24.4%, #1D22E6 100%)",
                        }}
                    >
                        Entrar
                    </LoadingButton>
                </Grid>
            </Grid>
        </Grid>
    )
}